import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitInquiry = (payload) =>
  api.post("/inquiries", payload).then((r) => r.data);

const authApi = axios.create({ baseURL: API, withCredentials: true });

export const login = (email, password) =>
  authApi.post("/auth/login", { email, password }).then((r) => r.data);

export const logout = () => authApi.post("/auth/logout").then((r) => r.data);

export const fetchMe = () => authApi.get("/auth/me").then((r) => r.data);

export const fetchInquiries = () =>
  authApi.get("/inquiries").then((r) => r.data);

export const updateInquiryStatus = (id, status) =>
  authApi.patch(`/inquiries/${id}`, { status }).then((r) => r.data);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
